/*
*
* File JS per la Charter Destinations
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './charter-destinations.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

/********************************
 *  initialize                  *
 *  Initialize MAP              *
 *******************************/

let globalMarker = [];
let markerCluster;
let map;
const markerMap = {};
let infowindow = '';
const markers = [];
let bounds;
const list = [];
let lastOpenedInfoWindow;

/*********************************
 * get_points                    *
 * retrieve point to show in map *
 * prepare global object markers *
 * @param map google map object  *
 * @param lat current latitude   *
 * @param map current longitude  *
 *********************************/
function get_points(map, lat, lon) {


    let add_coords = '';
    if (lat != null && lon != null) {
        add_coords = '/' + lat + ',' + lon;
    }

    // Definisci una variabile per tenere traccia del marker attivo
    let activeMarker = null;


    jQuery.getJSON('/wp-json/immedia-api/v1/destinations', function (json1) {

        let i = 0;

        jQuery.each(json1.items, function (key, item) {
            let data = item.location;
            let permalink = item.permalink;

            const pinLocator =  destination_object.theme_url  + "/assets/img/icons/pin-locator.svg?v=3.1";

            // prepare markers
            const latLng = new google.maps.LatLng(data.lat, data.lng);
            const markerData = {
                position: latLng,
                //content: contentString,
                map: map,
                icon: pinLocator,
                title: item.name,
                id: i
            };

            const marker = new google.maps.Marker(markerData);

            
            google.maps.event.addListener(marker, "click", function() {                
                if(permalink){
                    window.location.href = permalink
                }
            });


            markerMap["element" + i] = marker;

  
            infowindow = new google.maps.InfoWindow({
                maxWidth: 380,
                maxHeight: 185,
            });

            markers.push(marker);


            const jsonData = {
                // "HTML": ContentList,
                "lat": data.lat,
                "lon": data.lng
            };
            // used to reorder list points by distance from center when map is moved
            list.push(jsonData);


            i++;

        });


        jQuery('#showroom_filter input[type=checkbox]').on('click', function () {
            tipologia(this.value);
        });

        //var clusterOptions = {ignoreHidden: true };

        const clusterOptions =
            {
                ignoreHidden: true,
                maxZoom: 6,
                styles: [{
                    textColor: 'white',
                    url: destination_object.theme_url  + "/assets/img/icons/cluster.svg?v=1231",
                    width: 30,
                    height: 30
                },
                    {
                        textColor: 'white',
                        url:  destination_object.theme_url  + "/assets/img/icons/cluster.svg?v=1231",
                        width: 40,
                        height: 40
                    },
                    {
                        textColor: 'white',
                        url: destination_object.theme_url  + "/assets/img/icons/cluster.svg?v=1231",
                        width: 50,
                        height: 50
                    }]
            };

        markerCluster = new MarkerClusterer(map, markers, clusterOptions);

        //console.log('check '+map.getBounds());
        // hide list elements outside map or non in chosen category
        //hide_list_elements(markers, map);

    });
}

function initialize() {
    const styles =
    [
        {
            "featureType": "all",
            "elementType": "labels.text",
            "stylers": [
                {
                    "color": "#878787"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f9f5ed"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#c9c9c9"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#aee0f4"
                }
            ]
        }
    ];

    const styledMap = new google.maps.StyledMapType(styles, {name: "Styled Map"});

    const startZoom = 5;
    const minZoom = 2;

    const mapOptions = {
        zoom: startZoom,
        zoomControl: true,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        mapTypeControlOptions: {
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
        }
    };
    
    map = new google.maps.Map(document.getElementById('map'), mapOptions);
    bounds = new google.maps.LatLngBounds();


    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    /*******************************
     *  bind                       *
     *  Bind events for map        *
     *******************************/
    function bind(eventName) {
        google.maps.event.addListener(map, eventName, function () {
            //alert('fired');
            // reorder_list();
            // hide_list_elements(markers, map);

            if (eventName == 'zoom_changed') {
                //blocchiamo il minimo dello zoom a
                if (map.getZoom() < minZoom) {
                    map.setZoom(minZoom);
                }
            }
        });
    }

    bind('zoom_changed');
    bind('idle');

    // query string params (NOT USED)
    const url_string = window.location.href;
    const url = new URL(url_string);
    const myposition = url.searchParams.get('myposition');
    const lat = url.searchParams.get('lat');
    const lon = url.searchParams.get('lon');

    /*******************************
     * isFloat                     *
     * Check if number is float    *
     *******************************/
    function isFloat(n) {
        const value = parseFloat(n);
        return Number(value) === value && value % 1 !== 0;
    }


    // not yet used!
    if (myposition === 1 && isFloat(lat) && isFloat(lon)) {
        get_points(map, lat, lon);
        map.setCenter(new google.maps.LatLng(lat, lon));
        map.setZoom(9);
    }

    // not yet used!
    else {

        // center map about this localization
        const center_lat = destination_object.gmaps_init.lat;
        const center_lng = destination_object.gmaps_init.lng;
        const center = new google.maps.LatLng(center_lat, center_lng);

        map.setCenter(center);
        map.setZoom(destination_object.gmaps_init.zoom);

        // retrieve points
        setTimeout(function () {
            get_points(map, center_lat, center_lng);
        }, 1000)
    }

    globalMarker = markers.slice();

} //End Function Initialize

window.addEventListener('DOMContentLoaded', (e) => {

initialize();

});

//--------------------------------------------------------------------//